import { render, staticRenderFns } from "./historique_paiement.vue?vue&type=template&id=58773a10"
import script from "./historique_paiement.vue?vue&type=script&lang=js"
export * from "./historique_paiement.vue?vue&type=script&lang=js"
import style0 from "./historique_paiement.vue?vue&type=style&index=0&id=58773a10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports